import request from '@/utils/request';
import SERVICE from './enums';
//------------// 图表订阅模块-----------------
// 新增
export function addChartSub(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateSubscribe`,
    method: "post",
    data
  });
}

// 详情 
export function getChartSubDetail(params) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateSubscribe/detail`,
    method: "get",
    params
  });
}

// del 
export function delChartSub(params)  {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateSubscribe/removeById`,
    method: "delete",
    params,
  });
}

// update
export function updateChartSub(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateSubscribe/updateById`,
    method: "put",
    data
  });
}

// updateStatus
export function updateStatusChartSub(params) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateSubscribe/updateStatus`,
    method: "put",
    data: {},
    params
  });
}

// search
export function searchChartSubList(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateSubscribe/page`,
    method: "post",
    data
  });
}

// 更新分析模型
export function chartSubDairy(params) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateSubscribe/queryExecLogs`,
    method: "get",
    params
  });
}

